import { Navigate, Outlet } from "react-router-dom";
import { UserData } from "../types/user-data.type";

interface Props {
  roles: string[];
}

export default function ProtectedRoute({ roles }: Props) {
  const raw = localStorage.getItem("user");
  if (!raw) return <Navigate to="/login" replace />;

  const userData: UserData = JSON.parse(raw ?? '{}');

  if (userData.roles.find(role => roles.includes(role)))
    return <Outlet />;
  return <Navigate to="/login" replace />;

}
